import React from 'react';
import { useSelector } from 'react-redux';
import Image from 'next/image';
import { Box, Button, Stack, Typography } from '@mui/material';
import { getUserFreeTrialEligible, trackEvent } from '@surfline/web-common';
import { WHATS_NEW_URL } from 'common/constants';

import ErrorBoundary from 'components/ErrorBoundary';
import type { SegmentProperties } from 'types/analytics';

import styles from './LiveWindPaywall.module.scss';
// @ts-expect-error Image can't be found on this path
import paywallImage from '../../../public/images/Paywall.png';

export interface LiveWindPaywallProps {
  error?: boolean;
  segmentProperties?: SegmentProperties;
}

export const LiveWindPaywall: React.FC<LiveWindPaywallProps> = ({ error, segmentProperties }) => {
  const freeTrialEligible = useSelector(getUserFreeTrialEligible);
  const learnMoreSegmentProps = {
    linkLocation: 'Live Wind Screen Modal',
    category: 'cam & reports',
    linkName: 'live wind paywall learn more',
    linkUrl: WHATS_NEW_URL,
  };

  return (
    <Box
      data-testid="paywall"
      className={styles.liveWindPaywall}
      alignItems="center"
      display="flex"
      justifyContent="center"
      flexDirection="column"
    >
      <ErrorBoundary
        error={error}
        errorBoundaryId="live-wind-paywall"
        render={() => (
          <Stack
            className={styles.error}
            direction="row"
            justifyContent="center"
            alignItems="center"
          >
            <Typography variant="caption1" className={styles.errorText} color="text.brandSecondary">
              Something went wrong here.
            </Typography>
          </Stack>
        )}
      >
        <Image unoptimized src={paywallImage} alt="paywall" width="235" height="390" />
        <Typography variant="title3" component="h1" className={styles.title} color="black">
          Get real-time wind data.
        </Typography>
        <Typography
          variant="caption1"
          component="h2"
          className={styles.subtitle}
          color="text.brandSecondary"
        >
          Make the call with real-time wind speed and direction straight from the beach.
        </Typography>
        <Button
          href="https://www.surfline.com/upgrade"
          variant="primary"
          size="medium"
          sx={{ marginLeft: 1 }}
          className={styles.upgradeButton}
          onClick={() => {
            trackEvent('Clicked Subscribe CTA', segmentProperties);
          }}
        >
          {freeTrialEligible ? 'Go Premium' : 'Upgrade'}
        </Button>
        <Button
          className={styles.learnMoreButton}
          variant="text"
          href={WHATS_NEW_URL}
          onClick={() => {
            trackEvent('Clicked Link', learnMoreSegmentProps);
          }}
        >
          Learn more
        </Button>
      </ErrorBoundary>
    </Box>
  );
};

export default LiveWindPaywall;
